import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, Outlet, useParams, json } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { Buffer } from 'buffer';

import { SetGame } from './store.js';
import { User } from './user.js';


function Mypage() {

  const store = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();




  useEffect(() => {




  }, [])




  return (
    <>


      {User(localStorage.getItem('uuid'), 'my')}


    </>
  )
}

export default Mypage;